import { parametersProvider } from '@dialogexe/cw-parameters-provider/ParametersProvider';
import logger from '../../logger/Logger';

export function registerParameters() {
    const parameters = require('../../../parameters.json');
    const config = require('../../../config/config.json');

    logger.logInfo('registering parameters...from registerParameters.ts');

    parametersProvider.register({ ...parameters, site: config });

    return Promise.resolve(true);
}
